import { DeliveryDining, HourglassBottom, Microwave, RoomService, TaskAlt } from '@mui/icons-material';
import { OrderItemStatus as OrderItemStatusType, OrderStatus } from '../apiTypes';

type Props = {
  status: OrderItemStatusType | OrderStatus;
  size?: 'small' | 'large' | 'medium';
  color?: 'disabled' | 'action' | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

const OrderItemStatus = ({ status, size, color }: Props) => {
  if (status === 'ordered') {
    return <HourglassBottom color={color || 'disabled'} fontSize={size} />;
  }
  if (status === 'processing') {
    return <Microwave color={color || 'secondary'} fontSize={size} />;
  }
  if (status === 'ready') {
    return <RoomService color={color || 'warning'} fontSize={size} />;
  }
  if (status === 'complete') {
    return <TaskAlt color={color || 'success'} fontSize={size} />;
  }
  if (status === 'delivering') {
    return <DeliveryDining color={color || 'secondary'} fontSize={size} />;
  }
  return null;
};
export default OrderItemStatus;
